/**
 * Setup script for websites
 * @author Michel Heitbrink
 */
import $ from 'jquery';
import { Slider, Dropdown } from 'foundation-sites';
import FormElements from './FormElements';
import Validator from './Validator';

class Setup {

    constructor(){}

    init(options) {

        const defaultOptions = {
            assign: {
                formElements: true,
                slider: true,
                dropdown: true,
                validator: true
            },
            validateOptions : {}
        };

        options = Object.assign(defaultOptions, options);

        /**
         * Assign Plugins weh page is loaded
         */
        document.addEventListener('DOMContentLoaded', () => {

            /**
             * Assign by default foundation slider
             */
            if ( options.assign.slider ) {

                document.querySelectorAll('[data-slider]').forEach( (slider) => {
                    new Slider($(slider));
                });

            }

            /**
             * Assign by default foundation dropdown
             */
            if ( options.assign.dropdown ) {

                document.querySelectorAll('[data-dropdown]').forEach( (dropdown) => {
                    new Dropdown($(dropdown));
                });

            }

            /**
             * Assign the validator to forms
             */

            if ( options.assign.validator ) {

                const validator = new Validator(options.validateOptions);
                validator.init();

            }

            /**
             * Add javascript to inputs
             */
            if ( options.assign.formElements ) {

                const formElements = new FormElements();
                formElements.apply();
            }

        }, false);

    }
}

export default new Setup();
